module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-content pp-content--fullscreen"
  }, [(_vm.$root.view == 'mobile') ? _c('div', {
    staticClass: "pp-mobile-back pp-mobile-back--light",
    on: {
      "click": function($event) {
        return _vm.$root.mobileBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-left"
  })]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.artist) ? _c('div', {
    staticClass: "pp-artist-view"
  }, [_c('div', {
    staticClass: "pp-artist-view__sidebar",
    style: ({
      backgroundImage: 'url(\'' + _vm.artist.image + '\')'
    })
  }, [_c('div', {
    staticClass: "pp-artist-view__sidebar__container"
  }, [_c('div', {
    staticClass: "pp-artist-view__title"
  }, [_vm._v(_vm._s(_vm.artist.display_name))]), _vm._v(" "), _c('div', {
    staticClass: "pp-artist-view__stats"
  }, [_vm._v("\n                    " + _vm._s(_vm.totalAlbums) + " albums, " + _vm._s(_vm.totalTracks) + " tracks\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "pp-artist-view__summary",
    domProps: {
      "innerHTML": _vm._s(_vm.artist.description)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pp-artist-view__main"
  }, [_c('div', {
    staticClass: "pp-tabs"
  }, [_c('div', {
    staticClass: "pp-tabs__headers"
  }, [_c('div', {
    class: {
      'pp-tabs__headers__header': 1,
      'pp-tabs__headers__header--active': _vm.view == 'albums'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/browse/artists/' + _vm.artist.id
    }
  }, [_vm._v("\n                            Albums\n                        ")])], 1), _vm._v(" "), _c('div', {
    class: {
      'pp-tabs__headers__header': 1,
      'pp-tabs__headers__header--active': _vm.view == 'tracks'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/browse/artists/' + _vm.artist.id + '/tracks'
    }
  }, [_vm._v("\n                            Tracks\n                        ")])], 1)]), _vm._v(" "), (_vm.view == 'albums') ? _c('div', {
    staticClass: "pp-tabs__content"
  }, [_c('album-grid', {
    attrs: {
      "reached-end": _vm.reachedEnd,
      "paginating": _vm.paginating,
      "can-paginate": true,
      "items": _vm.albums
    },
    on: {
      "paginate": _vm.loadMore
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.view == 'tracks') ? _c('div', {
    staticClass: "pp-tabs__content"
  }, [_c('track-list', {
    attrs: {
      "reached-end": _vm.reachedEnd,
      "paginating": _vm.paginating,
      "can-paginate": true,
      "items": _vm.tracks
    },
    on: {
      "paginate": _vm.loadMore
    }
  })], 1) : _vm._e()])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d918804c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/routes/ViewArtist.vue
// module id = 141
// module chunks = 0 1